<template>
    <div>
        <h3 v-b-tooltip.hover="`（${detailForm?.name}）`" class="text-truncate" style="position: absolute; top: -40px; left: 40px">
            （{{ detailForm?.name }}）
        </h3>
        <div class="card-header">
            <div class="d-flex">
                <div class="title--screen" style="white-space: nowrap">
                    {{ $t('managerForm.analytics.downloadData') }}
                </div>
            </div>
        </div>
        <div class="card-body">
            <template v-if="type === 'manager'">
                <div class="form-group row">
                    <label class="col-sm-1" style="min-width: 180px">範囲指定</label>
                    <div class="col-sm-9">
                        <div class="d-flex" style="gap: 1rem">
                            <DateNormal
                                :full_date.sync="initFormDownloadData.filter_start_date"
                                :config.sync="configDateNormal.configFieldStartDate"
                                @blur="onHandleValidate(configDateNormal.configFieldStartDate, 'compare-date')"
                            >
                                <div v-if="configDateNormal.configFieldStartDate.error" class="invalid-feedback d-block">
                                    <span>{{ configDateNormal.configFieldStartDate.errorText }}</span>
                                </div>
                            </DateNormal>
                            <span class="mt-2">～</span>
                            <DateNormal
                                :full_date.sync="initFormDownloadData.filter_end_date"
                                :config.sync="configDateNormal.configFieldEndDate"
                                @blur="onHandleValidate(configDateNormal.configFieldEndDate, 'compare-date')"
                            >
                                <div v-if="configDateNormal.configFieldEndDate.error" class="invalid-feedback d-block">
                                    <span>{{ configDateNormal.configFieldEndDate.errorText }}</span>
                                </div>
                            </DateNormal>
                            <!-- <div>
                            <button type="button" class="btn btn-outline-success" @click="onHandleCheckDate">件数確認</button>
                        </div> -->
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1" style="min-width: 180px">ダウンロード形式を選択</label>
                    <div class="col-sm-9 d-flex">
                        <div v-for="(itemType, idx) in TYPE_EXPORT" :key="itemType.name">
                            <InputRadio
                                class="mr-4"
                                :model.sync="initFormDownloadData.exportType"
                                :name="`export-type`"
                                :id="`type-1--${idx}`"
                                :value="itemType.value"
                                :label="itemType.name"
                            />
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1" style="min-width: 180px">{{ $t('managerForm.analytics.downloadImage') }}</label>
                    <div class="col-sm-9 d-flex">
                        <div v-for="(imgType, idx) in TYPE_EXPORT_IMAGE" :key="imgType.name">
                            <InputRadio
                                class="mr-4"
                                :model.sync="initFormDownloadData.image_export_type"
                                :name="`export-img-type`"
                                :id="`type-img--${idx}`"
                                :value="imgType.value"
                                :label="imgType.name"
                            />
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1" style="min-width: 180px">ダウンロード項目選択 </label>
                    <div class="col-sm-9">
                        <div style="padding: 0px 30px 17px 0; font-size: 13px; border-bottom: #d8d8d8 1px solid" class="mb-3">
                            <InputCheckBox
                                style="min-width: 100px"
                                :model.sync="checkAllDown"
                                :id="`checkAllDown`"
                                :value="checkAllDown"
                                :label="`全選択`"
                                @change="onHandleCheckAllDown"
                            />
                        </div>
                        <div style="display: grid; max-width: 100%; grid-auto-rows: auto; grid-template-columns: repeat(3, 33%)">
                            <div v-for="item in listFileNeedDownload" :key="item.id" class="pb-2">
                                <InputCheckBox
                                    style="min-width: 100px"
                                    :model.sync="listFileChecked"
                                    :id="`listFileChecked-${item.id}`"
                                    :value="item.id"
                                    :label="item.block_name"
                                    @change="onHandleCheckFile(item.id)"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-if="type === 'mail'">
                <div class="form-group row">
                    <label class="col-sm-1" style="min-width: 210px">ダウンロード形式を選択</label>
                    <div class="col-sm-9 d-flex">
                        <div v-for="(itemType, idx) in TYPE_EXPORT" :key="itemType.name">
                            <InputRadio
                                class="mr-4"
                                :model.sync="initFormDownloadData.exportIType"
                                :name="`exportIType`"
                                :id="`typeI--${idx}`"
                                :value="itemType.value"
                                :label="itemType.name"
                            />
                        </div>
                    </div>
                </div>
            </template>
            <template v-if="isSerialType">
                <div class="form-group row">
                    <label class="col-sm-1" style="min-width: 180px">範囲指定</label>
                    <div class="col-sm-9">
                        <div class="d-flex" style="gap: 1rem">
                            <DateNormal
                                :full_date.sync="initFormDownloadData.filter_start_date"
                                :config.sync="configDateNormal.configFieldStartDate"
                                @blur="onHandleValidate(configDateNormal.configFieldStartDate, 'compare-date')"
                            >
                                <div v-if="configDateNormal.configFieldStartDate.error" class="invalid-feedback d-block">
                                    <span>{{ configDateNormal.configFieldStartDate.errorText }}</span>
                                </div>
                            </DateNormal>
                            <span class="mt-2">～</span>
                            <DateNormal
                                :full_date.sync="initFormDownloadData.filter_end_date"
                                :config.sync="configDateNormal.configFieldEndDate"
                                @blur="onHandleValidate(configDateNormal.configFieldEndDate, 'compare-date')"
                            >
                                <div v-if="configDateNormal.configFieldEndDate.error" class="invalid-feedback d-block">
                                    <span>{{ configDateNormal.configFieldEndDate.errorText }}</span>
                                </div>
                            </DateNormal>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1" style="min-width: 180px">ダウンロード形式を選択</label>
                    <div class="col-sm-9 d-flex">
                        <div v-for="(itemType, idx) in TYPE_EXPORT" :key="itemType.name">
                            <InputRadio
                                class="mr-4"
                                :model.sync="initFormDownloadData.exportBType"
                                :name="`exportBType`"
                                :id="`typeI--${idx}`"
                                :value="itemType.value"
                                :label="itemType.name"
                            />
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1" style="min-width: 180px">{{ $t('managerForm.analytics.downloadImage') }}</label>
                    <div class="col-sm-9 d-flex">
                        <div v-for="(imgType, idx) in TYPE_EXPORT_IMAGE" :key="imgType.name">
                            <InputRadio
                                class="mr-4"
                                :model.sync="initFormDownloadData.image_export_type"
                                :name="`export-img-type`"
                                :id="`type-img--${idx}`"
                                :value="imgType.value"
                                :label="imgType.name"
                            />
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1" style="min-width: 180px">ダウンロード項目選択</label>
                    <div class="col-sm-9">
                        <div style="padding: 0px 30px 17px 0; font-size: 13px; border-bottom: #d8d8d8 1px solid" class="mb-3">
                            <InputCheckBox
                                style="min-width: 100px"
                                :model.sync="checkAllDown"
                                :id="`checkAllDownSerial`"
                                :value="checkAllDown"
                                :label="`全選択`"
                                @change="onHandleCheckAllDown"
                            />
                        </div>
                        <div style="display: grid; max-width: 100%; grid-auto-rows: auto; grid-template-columns: repeat(3, 33%)">
                            <div v-for="item in listFileNeedDownload" :key="item.id" class="pb-2">
                                <InputCheckBox
                                    style="min-width: 100px"
                                    :model.sync="listFileChecked"
                                    :id="`listFileCheckedSerial-${item.id}`"
                                    :value="item.id"
                                    :label="item.block_name"
                                    @change="onHandleCheckFile(item.id)"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <div class="d-flex justify-content-center mt-5">
                <h5 v-if="isProcessing">
                    {{ $t('common.processDownload') }}
                    <span>({{ downloadProgress }}%)</span>
                </h5>
                <button
                    v-else
                    type="button"
                    class="btn btn-success"
                    style="padding: 0.5rem 7rem; background-color: #339162"
                    :disabled="listFileChecked.length === 0 && !isSerialType"
                    @click="onHandleExportBlock(type)"
                >
                    ダウンロード
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import DateNormal from '@/components/DateCustoms/DateNormal/main.vue';
import runJobMinxin from '@/mixins/runJobMinxin';

import { validateAllField, validateField } from '@/utils/validate';
import { STR_DATE } from '@/utils/format';
import { InputCheckBox, InputRadio } from '@/components/Input';
import { managerFormMethods } from '@/state/helpers';
import { handleDownFile } from '@/utils/format';
import { showMessage } from '@/utils/messages';
import { ALL_BLOCK_TYPE } from '@/config/constants';
import { LIST_DEFAULT_DOWNLOAD, TABS, TYPE_EXPORT, TYPE_DATA_EXPORT, TYPE_EXPORT_IMAGE, onInitDateNormal, onInitFormDownloadData } from './constants';
import { ID_PAGE_TYPE } from '@/views/pages/phase2/manager-form/constants';
import { getFormattedHeader } from '@/views/pages/phase2/manager-form/analytics/handlers.js';

export default {
    name: 'DownloadData',
    components: {
        DateNormal,
        InputCheckBox,
        InputRadio
    },
    props: {
        detailForm: {
            type: Object,
            default: () => ({})
        },
        type: {
            type: String,
            default: 'manager'
        },
        queryTableFilter: {
            type: String,
            default: ''
        },
        isSubmitted: {
            type: Array,
            default: () => []
        },
        configModal: {
            type: Object,
            default: () => ({})
        }
    },
    mixins: [runJobMinxin],
    computed: {
        isSerialType() {
            return this.type === 'serial';
        }
    },
    data() {
        return {
            initFormDownloadData: onInitFormDownloadData(),
            configDateNormal: onInitDateNormal(),
            STR_DATE: STR_DATE,
            checkAllDown: true,
            listFileChecked: [],
            listFileNeedDownload: [],
            LIST_DEFAULT_DOWNLOAD,
            TABS: TABS.filter((tab) => {
                switch (this.detailForm.type) {
                    case ID_PAGE_TYPE.A:
                        return tab.type_page_id === this.detailForm.type;
                }
                return tab;
            }),
            defaultDownloadFormI: [
                {
                    id: 'registration_email',
                    block_name: '本登録メール'
                },
                {
                    id: 'token_url',
                    block_name: '本番URL'
                }
            ],
            TYPE_EXPORT,
            TYPE_DATA_EXPORT,
            TYPE_EXPORT_IMAGE,
            isProcessing: false,
            downloadProgress: 0
        };
    },
    methods: {
        ...managerFormMethods,
        onInitDateNormal,
        onInitFormDownloadData,

        async onGetListBlockOfForm() {
            try {
                const dataRes = await this.getListBlockOfForm(this.$route.query.id);
                this.listFileNeedDownload =
                    dataRes?.length > 0
                        ? [
                              ...dataRes
                                  .filter((item) => ![ALL_BLOCK_TYPE.BLOCK_DISPLAY_1, ALL_BLOCK_TYPE.BLOCK_DISPLAY_2].includes(item.block_type))
                                  .map((item) => {
                                      return {
                                          ...item,
                                          ...getFormattedHeader(item, { key: 'download' })
                                      };
                                  }),
                              ...this.LIST_DEFAULT_DOWNLOAD
                          ]
                        : [];
                switch (this.detailForm.type) {
                    case ID_PAGE_TYPE.I:
                        this.listFileNeedDownload = [...this.listFileNeedDownload, ...this.defaultDownloadFormI];
                        break;
                    case ID_PAGE_TYPE.B:
                        this.listFileNeedDownload = [...this.configModal.listBlockSerial, ...this.listFileNeedDownload];
                        break;
                }
            } catch (error) {
                console.log('error', error);
            }
        },

        onHandleValidate(configField, action = null) {
            validateField(configField);
            if (action == 'compare-date') {
                this.validateEndDate(
                    this.configDateNormal.configFieldStartDate,
                    this.configDateNormal.configFieldStartDate.valueSync,
                    this.configDateNormal.configFieldEndDate.valueSync
                );
            }
        },

        validateEndDate(configField, startDateStr, endDateStr) {
            let isCheck = true;
            const startDate = moment(startDateStr, STR_DATE);
            const endDate = moment(endDateStr, STR_DATE);
            if (!startDateStr || !endDateStr) return isCheck;
            if (!endDate.isSameOrAfter(startDate)) {
                isCheck = false;
                configField.error = true;
                configField.errorText = this.$t('validateField.compareDate');
            }
            return isCheck;
        },

        onHandleCheckDate() {
            let checkDate = validateAllField(this.configDateNormal);
            let checkCompareDate = this.validateEndDate(
                this.configDateNormal.configFieldStartDate,
                this.initFormDownloadData.filter_start_date,
                this.initFormDownloadData.filter_end_date
            );
            if (!checkDate || !checkCompareDate) return false;
            return true;
        },

        onHandleCheckFile() {
            this.checkAllDown = this.listFileChecked.length == this.listFileNeedDownload.length;
        },

        onHandleCheckAllDown(val) {
            if (val) {
                this.listFileChecked = this.listFileNeedDownload.map((item) => item.id);
            } else {
                this.listFileChecked = [];
            }
        },

        async onHandleExportBlock(type) {
            if (!this.onHandleCheckDate() || this.isProcessing) return;
            this.isProcessing = true;
            let copyChecked = this.listFileChecked.slice();
            let commonPayload = {
                include_email_status: true
            };
            if (type === 'manager') {
                let payload = {
                    body: {
                        form_id: this.$route.query?.id ? Number(this.$route.query?.id) : null,
                        export_type: this.initFormDownloadData.exportType,
                        filter_start_date: this.initFormDownloadData.filter_start_date,
                        filter_end_date: this.initFormDownloadData.filter_end_date,
                        browser: copyChecked.includes('Browser') ? true : false,
                        ip_address: copyChecked.includes('IPAddress') ? true : false,
                        link_source: copyChecked.includes('LinkSource') ? true : false,
                        registration_email: copyChecked.includes('registration_email') ? true : false,
                        token_url: copyChecked.includes('token_url') ? true : false,
                        block_ids: copyChecked.filter(
                            (item) => !['IPAddress', 'LinkSource', 'Browser', 'registration_email', 'token_url'].includes(item)
                        ),
                        image_export_type: this.initFormDownloadData.image_export_type || 'zip',
                        ...commonPayload
                    },
                    param: this.queryTableFilter ? `?${this.queryTableFilter}` : ''
                };
                const onProgress = (r, t, p) => {
                    this.downloadProgress = p;
                };
                try {
                    const dataExportRes = await this.exportDataBlockForm(payload);
                    if (dataExportRes?.status && dataExportRes?.data?.file_id) {
                        let successCallback = async (res) => {
                            this.downloadProgress = 100;
                            await handleDownFile(res?.path, res?.file_name, onProgress).catch(() => {
                                showMessage(400, this.$bvToast, this.$t('system.error'));
                            });
                            showMessage(200, this.$bvToast, 'ダウンロード処理が完了しました。');
                            this.isProcessing = false;
                            this.downloadProgress = 0;
                        };
                        let errorCallback = (res) => {
                            showMessage(400, this.$bvToast, this.$t(res?.data?.error_message || 'system.error'));
                            this.isProcessing = false;
                            this.downloadProgress = 0;
                        };
                        await this.startPollingJobStatus(dataExportRes?.data?.file_id, successCallback, errorCallback, {
                            ...dataExportRes?.data
                        });
                    } else {
                        showMessage(dataExportRes?.code || 400, this.$bvToast, this.$t(dataExportRes?.message || 'system.error'));
                        this.isProcessing = false;
                        this.downloadProgress = 0;
                    }
                } catch (error) {
                    showMessage(error?.code || 400, this.$bvToast, this.$t(error?.message || 'system.error'));
                    this.isProcessing = false;
                    this.downloadProgress = 0;
                }
            } else if (type === 'mail') {
                let payload = {
                    id: this.$route.query?.id ? Number(this.$route.query?.id) : null,
                    body: {
                        is_submitted: this.isSubmitted,
                        export_type: this.initFormDownloadData.exportIType,
                        ...commonPayload
                    },
                    param: this.queryTableFilter ? `?${this.queryTableFilter}` : ''
                };
                const onProgress = (r, t, p) => {
                    this.downloadProgress = p;
                };
                try {
                    const dataExportRegisterMail = await this.exportDataRegisterEmail(payload);
                    if (dataExportRegisterMail?.code !== 200) {
                        showMessage(dataExportRegisterMail?.code, this.$bvToast, this.$t(dataExportRegisterMail?.message || 'system.error'));
                        this.isProcessing = false;
                        this.downloadProgress = 0;
                        return;
                    }
                    this.downloadProgress = 100;
                    await handleDownFile(
                        dataExportRegisterMail?.data?.url,
                        dataExportRegisterMail?.data?.file_name
                            ? dataExportRegisterMail?.data?.file_name
                            : dataExportRegisterMail?.data?.url.split('/').pop(),
                        onProgress
                    );
                    this.isProcessing = false;
                    this.downloadProgress = 0;
                } catch (error) {
                    showMessage(error?.code, this.$bvToast, this.$t(error?.message || 'system.error'));
                    this.isProcessing = false;
                    this.downloadProgress = 0;
                }
            } else if (this.isSerialType) {
                let payload = {
                    id: this.$route.query?.id ? Number(this.$route.query?.id) : null,
                    body: {
                        filter_start_date: this.initFormDownloadData.filter_start_date,
                        filter_end_date: this.initFormDownloadData.filter_end_date,
                        export_type: this.initFormDownloadData.exportBType,
                        image_export_type: this.initFormDownloadData.image_export_type || 'zip',
                        browser: copyChecked.includes('Browser') ? true : false,
                        ip_address: copyChecked.includes('IPAddress') ? true : false,
                        link_source: copyChecked.includes('LinkSource') ? true : false,
                        block_ids: copyChecked.filter((item) => !['IPAddress', 'LinkSource', 'Browser'].includes(item)),
                        ...commonPayload
                    },
                    param: this.queryTableFilter ? `?${this.queryTableFilter}` : ''
                };
                const onProgress = (r, t, p) => {
                    this.downloadProgress = p;
                };
                try {
                    const dataExportRes = await this.downloadLotteryHistory(payload);
                    if (dataExportRes?.status && dataExportRes?.data?.file_id) {
                        let successCallback = async (res) => {
                            this.downloadProgress = 100;
                            await handleDownFile(res?.path, res?.file_name, onProgress).catch(() => {
                                showMessage(400, this.$bvToast, this.$t('system.error'));
                            });
                            showMessage(200, this.$bvToast, 'ダウンロード処理が完了しました。');
                            this.isProcessing = false;
                            this.downloadProgress = 0;
                        };
                        let errorCallback = (res) => {
                            showMessage(400, this.$bvToast, this.$t(res?.data?.error_message || 'system.error'));
                            this.isProcessing = false;
                            this.downloadProgress = 0;
                        };
                        await this.startPollingJobStatus(dataExportRes?.data?.file_id, successCallback, errorCallback, {
                            ...dataExportRes?.data
                        });
                    } else {
                        showMessage(dataExportRes?.code || 400, this.$bvToast, this.$t(dataExportRes?.message || 'system.error'));
                        this.isProcessing = false;
                        this.downloadProgress = 0;
                    }
                } catch (error) {
                    showMessage(error?.code || 400, this.$bvToast, this.$t(error?.message || 'system.error'));
                    this.isProcessing = false;
                    this.downloadProgress = 0;
                }
            }
        },

        onHandleCickTab() {
            this.initFormDownloadData = this.onInitFormDownloadData();
            this.configDateNormal = this.onInitDateNormal();
            this.checkAllDown = true;
            this.onHandleCheckAllDown(true);
        }
    },
    watch: {
        isProcessing: {
            handler(val) {
                if (this.configModal) {
                    this.$set(this.configModal, 'hideCloseButton', val);
                }
            },
            immediate: true,
            deep: true
        }
    },
    async mounted() {
        await this.onGetListBlockOfForm();
        this.onHandleCheckAllDown(true);
    }
};
</script>

<style lang="scss"></style>
